import { render } from "./DiningTable.vue?vue&type=template&id=ca3dd482"
import script from "./DiningTable.vue?vue&type=script&lang=js"
export * from "./DiningTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/psinclair/git/hitting-the-target-australia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__